import { createI18n } from 'vue-i18n';

// Import locale messages
import en from './locales/en.json';
import pl from './locales/pl.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

// Determine the initial locale
const getUserLanguage = () => {
  // Check localStorage first
  const savedLanguage = localStorage.getItem('user-language');
  if (savedLanguage && ['en', 'pl', 'fr', 'de'].includes(savedLanguage)) {
    return savedLanguage;
  }
  
  // If no saved preference, check browser language
  const browserLanguage = navigator.language.split('-')[0];
  if (['en', 'pl', 'fr', 'de'].includes(browserLanguage)) {
    return browserLanguage;
  }
  
  // Default to English
  return 'en';
};

// Create I18n instance
export const i18n = createI18n({
  legacy: false, // You must set `false`, to use Composition API
  locale: getUserLanguage(),
  fallbackLocale: 'en',
  messages: {
    en,
    pl,
    fr,
    de
  },
  silentTranslationWarn: true, // Suppress translation warnings in development
  silentFallbackWarn: true, // Suppress fallback warnings in development
  // Add any additional options as needed
});

// Default export for main.js
export default i18n;
